module.exports = __webpack_public_path__ + "img/kep7.1890b84a.jpg";